import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { XpoClockComponent } from './clock.component';

@NgModule({
  imports: [CommonModule],
  exports: [XpoClockComponent],
  declarations: [XpoClockComponent],
})
export class XpoClockModule {}
